import React, { useCallback, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import PostCompletionScreen from './PostCompletionScreen';
import { resolvePostCompletionPreviewScenario } from './postCompletionPreviewScenarios';

const previewShellStyle = {
  minHeight: '100vh',
  width: '100%',
  background:
    'radial-gradient(circle at 20% 20%, rgba(34,211,238,0.2), transparent 42%), #020617',
};

const previewHudStyle = {
  position: 'fixed',
  top: 12,
  left: 12,
  zIndex: 2200,
  width: 'min(820px, calc(100vw - 24px))',
  background: 'rgba(2,6,23,0.88)',
  border: '1px solid rgba(148,163,184,0.28)',
  color: '#dbeafe',
  borderRadius: 10,
  padding: '10px 12px',
  fontSize: 12,
  lineHeight: 1.4,
};

const linkStyle = {
  color: '#67e8f9',
  textDecoration: 'none',
  marginRight: 8,
  display: 'inline-block',
};

export default function PostCompletionPreviewPage() {
  const { scenario: scenarioFromPath } = useParams();
  const [lastAction, setLastAction] = useState('none');

  const resolved = useMemo(
    () => resolvePostCompletionPreviewScenario(scenarioFromPath),
    [scenarioFromPath],
  );
  const {
    scenario,
    invalidScenarioName,
    defaultScenarioName,
    validScenarioNames,
  } = resolved;

  const handleClose = useCallback(() => setLastAction('close'), []);
  const handlePrimaryAction = useCallback(() => setLastAction('primary'), []);
  const handleSecondaryAction = useCallback(() => setLastAction('secondary'), []);
  const handleShare = useCallback((payload = {}) => {
    const entityType = payload?.entityType || 'task';
    const entityId = payload?.entityId || payload?.id || 'unknown';
    setLastAction(`share:${entityType}:${entityId}`);
  }, []);

  return (
    <div style={previewShellStyle}>
      <div style={previewHudStyle} data-testid="completion-preview-title">
        <div>
          <strong>Completion Preview</strong>
          {` | scenario: ${scenario?.name || defaultScenarioName}`}
        </div>
        {invalidScenarioName ? (
          <div
            data-testid="completion-preview-invalid"
            style={{ marginTop: 6, color: '#fde68a' }}
          >
            {`Invalid scenario "${invalidScenarioName}". Showing fallback "${scenario?.name || defaultScenarioName}". Valid scenarios: ${validScenarioNames.join(
              ', ',
            )}`}
          </div>
        ) : null}
        <div style={{ marginTop: 6 }}>
          {`Last action: ${lastAction}`}
        </div>
        <div style={{ marginTop: 6 }}>
          {validScenarioNames.map((name) => (
            <Link
              key={name}
              to={`/_ui/localops/completion/${encodeURIComponent(name)}`}
              style={linkStyle}
            >
              {name}
            </Link>
          ))}
        </div>
      </div>

      <div
        data-testid="completion-preview-meta"
        data-scenarios={JSON.stringify(validScenarioNames)}
        data-default={defaultScenarioName}
        style={{ display: 'none' }}
      />
      <div
        data-testid="completion-preview-ready"
        data-ready="1"
        data-scenario={scenario?.name || defaultScenarioName}
        style={{ display: 'none' }}
      />

      <PostCompletionScreen
        open
        context={scenario?.context}
        completionContext={scenario?.context}
        playerBalance={scenario?.playerBalance}
        onPrimaryAction={handlePrimaryAction}
        onSecondaryAction={handleSecondaryAction}
        onShare={handleShare}
        onClose={handleClose}
      />
    </div>
  );
}

